import React from 'react';
import './_requestDetails.scss'

function RequestDetails({ request }) {
    return (
      <div className="request-tooltip-body">
        <div className="request-tooltip-arrow"></div>
        <div className="request-tooltip-content">
          <div className="d-flex">
            {!request.isTierChange && (
              <div className="request-tooltip-section">
                <p><strong>Date of Request</strong><br />{request.requestedDate?.slice(0, 10)}</p>
                <p><strong>Date of Change</strong><br />{request.updatedDate?.slice(0, 10)}</p>
              </div>
            )}
            <div className="request-tooltip-section">
              {request.slaTier && (
                <p><strong>SLA Tier</strong><br />{request.slaTier.name}({request.slaTier.requestNumber} requests per {request.slaTier.timePeriod} milli seconds)</p>
              )}
            </div>
            <div className="request-tooltip-section">
              <p><strong>{request.isTierChange ? 'Reason for change' : 'Request Reason'}</strong><br />{request.requestReason}</p>
              {request.status?.toLowerCase() === 'denied' && (
                <p><strong>Denied Reason</strong><br />{request.deniedReason}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    )
}

export default RequestDetails;
